import { useMutation } from '@tanstack/react-query';
import { RestEndpoints } from "../../../../../api/endpoints";
import getInstance from "../../../../../utils/rest";

type QueryErrorHandler = ((error: unknown, variables: void, context: unknown) => void | Promise<unknown>) | undefined;
type QuerySuccessHandler = ((data: unknown, variables: void, context: unknown) => void | Promise<unknown>) | undefined;

const cloneSystem = async (): Promise<void> => {
  await getInstance().post(RestEndpoints.SystemClone);
};

export const useStartCloningSystemQuery = (handleError: QueryErrorHandler, handleSuccess: QuerySuccessHandler) => {
  return useMutation({
    mutationFn: () => cloneSystem(),

    onError: handleError,
    onSuccess: handleSuccess,
  });
};
